import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"


import SidebarItem from './SidebarItem';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  sideBarList: {
    type: Array,
    default() {
      return [];
    },
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { "wrap-class": "scrollbar-wrapper" }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu, {
        "default-active": _ctx.$route.path,
        "unique-opened": false,
        "background-color": "#182546",
        "text-color": "#999999",
        "active-text-color": "#FFFFFF",
        "collapse-transition": "",
        collapse: false,
        mode: "vertical",
        router: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.sideBarList, (router, index) => {
            return (_openBlock(), _createBlock(_unref(SidebarItem), {
              key: index,
              item: router,
              "base-path": router.path
            }, null, 8, ["item", "base-path"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["default-active"])
    ]),
    _: 1
  }))
}
}

})